export enum LicenceTypes {
  Earthmoving = 'earthmoving_productivity',
  Drilling = 'drilling_stabilization_productivity',
  Demo = 'conx_app_1month_demo_licence',
  AwarenessUnits1to9 = 'leica_conx_awareness_1-9_units',
  AwarenessUnits10to29 = 'leica_conx_awareness_10-29_units',
  AwarenessUnits30to49 = 'leica_conx_awareness_30-49_units',
  AwarenessUnitsUnlimited = 'leica_conx_awareness_unlimited'
}